import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../../config";

const styles = {
  card: { border: "1px solid #ccc", borderRadius: 6, margin: "16px 0" },
  header: { textAlign: "center", fontWeight: 700, fontSize: 22, padding: "10px 8px" },
  table: { width: "100%", borderCollapse: "collapse" },
  th: { background: "#d9f0f2", border: "1px solid #000", padding: "10px", fontWeight: 700 },
  td: { border: "1px solid #000", padding: "10px" }
};

export default function JoiningToday() {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem("authToken");

    (async () => {
      try {
        const { data } = await axios.get(`${API_BASE_URL}/joiningToday`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });

        setRows(data?.data || []);
      } catch (e) {
        console.error(e);
      }
    })();
  }, []);

  return rows?.length > 0 ? (
    <div className="row clearfix">
      <div className="col-12 col-sm-12">
        <div className="card">
          <div className="card-header">
            <h5 className="mb-0 text-center">
              🎉 Welcome New Employees 🎉
            </h5>
          </div>

          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-hover table-striped text-nowrap table-vcenter mb-0">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Employee Id</th>
                    <th>Employee Name</th>
                    <th>Department</th>
                  </tr>
                </thead>

                <tbody>
                  {rows.map((r, i) => (
                    <tr key={`${r.employee_id}-${i}`}>
                      <td>{i + 1}</td>
                      <td>{r.employee_id}</td>
                      <td>
                        {`${r.first_name || ""} ${r.last_name || ""}`.trim()}
                      </td>
                      <td>{r.department_name || "-"}</td>
                    </tr>
                  ))}
                </tbody>

              </table>
            </div>
          </div>

        </div>
      </div>
    </div>
  ) : null;
}

